<div class="_avatar bg-{{name == 'N/A' ? 'muted' : color}} " placement="{{tooltipDirection}}" ngbTooltip="{{name == 'N/A' ? '' : name}}" tooltipClass="tooltip-small" *ngIf="name else noUser"><span *ngIf="name != 'N/A' else userNA">{{name.split(' ')[0][0]}}{{(name.split(' ')[1] || ' ')[0]}}</span></div>

<ng-template #noUser>
    <div class="_avatar bg-muted"></div>
</ng-template>

<ng-template #userNA>
    <span class="text-muted">N/A</span>
</ng-template>